"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecurrentProductDonationInterval = exports.hasCumulativeAnnualReceipt = exports.isMonthBasedSubscriptionInterval = void 0;
const product_donation_1 = require("../enums/product-donation");
const subscription_1 = require("../types/subscription");
const isMonthBasedSubscriptionInterval = (recurrenceInterval) => recurrenceInterval === subscription_1.SubscriptionRecurrenceInterval.Monthly ||
    recurrenceInterval === subscription_1.SubscriptionRecurrenceInterval.Quarterly ||
    recurrenceInterval === subscription_1.SubscriptionRecurrenceInterval.Yearly;
exports.isMonthBasedSubscriptionInterval = isMonthBasedSubscriptionInterval;
const CUMULATIVE_RECEIPT_INTERVALS = new Set([
    product_donation_1.ProductDonationRecurrenceInterval.Weekly,
    product_donation_1.ProductDonationRecurrenceInterval.BiWeekly,
    product_donation_1.ProductDonationRecurrenceInterval.Monthly,
    product_donation_1.ProductDonationRecurrenceInterval.Quarterly,
]);
const hasCumulativeAnnualReceipt = (recurrenceInterval) => !!recurrenceInterval && CUMULATIVE_RECEIPT_INTERVALS.has(recurrenceInterval);
exports.hasCumulativeAnnualReceipt = hasCumulativeAnnualReceipt;
const isRecurrentProductDonationInterval = (recurrenceInterval) => recurrenceInterval !== product_donation_1.ProductDonationRecurrenceInterval.OneTime;
exports.isRecurrentProductDonationInterval = isRecurrentProductDonationInterval;
